import CreatorCard from './CreatorCard'
import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";

function Creators() {
  const { t, parse } = useGlobal();
  const creatorsData = t("creators_data", {returnObjects: true});
  const productsData = t("products_data", {returnObjects: true});

  // Don't render the section if there's no data
  if (!creatorsData || creatorsData.length === 0) {
    return null;
  }

  return (
    <section id="creators" className="creators pt-16 lg:py-16 bg-secondary-500">
      {/* Title and Body */}
      <div className="creators__header max-w-4xl mx-auto px-8 lg:px-16 mb-12">
        <h2 className="creators__title font-medium font-header text-4xl lg:text-5xl text-white text-center mb-12">
          {t("sections_data.9.section_heading")}
        </h2>

        {/* Section Body */}
        <div className="creators__body font-body text-lg text-secondary-300 leading-relaxed text-center">
          {parse(t("sections_data.9.section_body"))}
        </div>
      </div>

      {/* Creator Cards */}
      <div className="creators__container">
        <div className="creators__grid space-y-8">
          {creatorsData.map(creator => (
            <CreatorCard
              key={creator.id}
              image={creator.creator_image}
              name={creator.creator_name}
              location={creator.creator_location}
              description={creator.creator_description}
              shopLink={creator.creator_url}
              logo={creator.creator_logo}
              instagramLink={creator.creator_ig}
              creatorId={creator.creator_id}
              products={productsData}
            />

          ))}
        </div>
      </div>
    </section>
  )
}

export default Creators
